import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import supportedLocales from './supportedLocales';

i18next
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: supportedLocales.map(l => l.code),
    defaultNS: 'common',
    ns: ['common', 'terms'],
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath:
        process.env.NODE_ENV === 'development'
          ? '/src/localization/locales/{{lng}}/{{ns}}.json'
          : '/locales/{{lng}}/{{ns}}.json'
    },
    debug: false
  });

export default i18next;
